import { Prediction } from '@app/graphql/types'

export const predictionMap = {
  [Prediction.NotOk]: 'nicht ok',
  [Prediction.Questionable]: 'fragwürdig',
  [Prediction.Inconclusive]: 'unklar',
  [Prediction.Ok]: 'ok'
}
